import React, { useState } from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const [sortBy, setSortBy] = useState("Featured");
  const [selectedMaterial, setSelectedMaterial] = useState("All");
  const [showMaterialFilter, setShowMaterialFilter] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Extract unique materials from product data
  const materials = [
    "All",
    "18k Gold",
    "Pearls",
    "Lapis",
    "Onyx",
    "Jade",
    "Quartz",
    "Carnelian",
    "Gold Vermeil",
    "Sterling Silver",
  ];

  // Filter and sort products
  const filteredProducts = productData
    .filter((product) => {
      if (selectedMaterial === "All") return true;
      return (
        product.material &&
        product.material.toLowerCase().includes(selectedMaterial.toLowerCase())
      );
    })
    .sort((a, b) => {
      switch (sortBy) {
        case "Newest":
          return b.id - a.id;
        case "Ascending Price":
          return parseFloat(a.price) - parseFloat(b.price);
        case "Descending Price":
          return parseFloat(b.price) - parseFloat(a.price);
        default:
          return a.id - b.id;
      }
    });

  const formatPrice = (price) => {
    return `$${parseFloat(price).toLocaleString()}`;
  };

  return (
    <div className="shop main">
      <Header />

      <main className="shop-content">
        {/* Hero Section */}
        <section className="shop-hero">
          <h1>New Collection</h1>
          <p>Discover the Spring Summer 2026 Collection</p>
        </section>

        {/* Filter Bar */}
        <section className="filter-bar">
          <div className="filter-left">
            <span className="result-count">
              {`${filteredProducts.length} products`}
            </span>
          </div>

          <div className="filter-right">
            {/* Materiality Filter */}
            <div className="filter-dropdown">
              <button
                className="filter-btn"
                onClick={() => setShowMaterialFilter(!showMaterialFilter)}
              >
                Filter by Materiality
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M2 4L6 8L10 4"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </button>

              {showMaterialFilter && (
                <div className="filter-menu">
                  {materials.map((material) => (
                    <button
                      key={material}
                      className={`filter-option ${
                        selectedMaterial === material ? "active" : ""
                      }`}
                      onClick={() => {
                        setSelectedMaterial(material);
                        setShowMaterialFilter(false);
                      }}
                    >
                      {material}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Sort By */}
            <div className="sort-dropdown">
              <span className="sort-label">Sort by:</span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="sort-select"
              >
                <option>Featured</option>
                <option>Newest</option>
                <option>Ascending Price</option>
                <option>Descending Price</option>
              </select>
            </div>
          </div>
        </section>

        {/* Product Grid */}
        <section className="product-grid">
          {filteredProducts.map((product) => (
            <Link
              onClick={toTop}
              to={`/shopDetails/${product.id}`}
              key={product.id}
              className="product-card"
            >
              <div className="product-image-container">
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
                {product.images && product.images.length > 1 && (
                  <div className="product-image-hover">
                    <img
                      src={product.images[1]}
                      alt={`${product.name} alternate view`}
                      className="product-image"
                    />
                  </div>
                )}
              </div>

              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">{formatPrice(product.price)}</p>
              </div>
            </Link>
          ))}
        </section>

        {/* Empty State */}
        {filteredProducts.length === 0 && (
          <div className="empty-state">
            <p>No products match your filters.</p>
            <button
              className="reset-btn"
              onClick={() => setSelectedMaterial("All")}
            >
              View all products
            </button>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}

export default Shop;
